import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ModalPopup from 'components/organisms/modal';
import UploadCsv from 'components/organisms/csvUpload';

const CsvUploadModal = ({
  isOpen,
  toggle,
  uploadCsvFile,
  sampleFileUrl,
  title,
}) => (
  <ModalPopup
    isOpen={isOpen}
    toggle={toggle}
    title={title}
    className="popup upload-csv-popup"
  >
    <div className="upload-csv-modal-body">
      <div className="download-sample">
        <Link to={sampleFileUrl} target="_blank" download>
          download sample
        </Link>
      </div>
      <UploadCsv uploadFile={(file) => uploadCsvFile(file)} />
      <div className="required-info">
        <b>Requirements</b>
        <ul>
          <li>File should be in csv format.</li>
          <li>File size should be less than 10MB.</li>
          <li>
            File template must be the same as in example, which can be
            downloaded.
          </li>
        </ul>
      </div>
    </div>
  </ModalPopup>
);

CsvUploadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  uploadCsvFile: PropTypes.func.isRequired,
  sampleFileUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CsvUploadModal;
